import { Observable } from 'rxjs';
import { VerificarMasterBackup } from '@src/core/domain/master-backup/master-backup.model';

export abstract class MasterBackupRepository {
    abstract verificarMasterBackup(): Observable<VerificarMasterBackup>;
}